<template>
    <div id="fund-destinations">
        <section class="section" :class="needsPadding ? 'section-padding' : ''">
            <div class="container">
                <div class="section-heading heading-left mb-0">
                    <span class="subtitle primary">
                        <slot name="subtitle"></slot>
                    </span>
                    <!-- WEB -->
                    <div class="row">
                        <div class="col-lg-12 mb--30">
                            <h2 class="font-weight-100 text-wrap-balance">
                                <slot name="title"></slot>
                            </h2>
                        </div>
                        <div class="col-lg-12">
                            <div class="row web-destinations">
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="100">
                                    <ImageCard title="Agronegocios." avatar="impact-agronegocios"
                                        :list="['Agricultura, apicultura y ganadería (Prácticas regenerativas, orgánicas y precisión).']"
                                        bgImg="agronegocios" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="200">
                                    <ImageCard title="Conservación." avatar="biodiversidad"
                                        :list="['Ecoturismo.', 'Certificación bonos de carbono.', 'Manejo forestal.']"
                                        bgImg="biodiversidad" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="300">
                                    <ImageCard title="Construcción." avatar="impact-construccion"
                                        :list="['Remodelaciones.', 'Edificaciones ecoeficientes.']" bgImg="construccion" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="400">
                                    <ImageCard title="Energia." avatar="energia"
                                        :list="['Energía renovable.', 'Eficiencia energética']" bgImg="energia" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="500">
                                    <ImageCard title="Movilidad." avatar="movilidad"
                                        :list="['Vehículos híbridos.', 'Vehículos eléctricos.']" bgImg="movilidad" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="600">
                                    <ImageCard title="Residuos." avatar="residuos"
                                        :list="['Economía circular.', 'Reuso y reciclaje.', 'Materiales alternativos.']"
                                        bgImg="residuos" />
                                </div>
                            </div>
                            <!-- MOBILE -->
                            <div class="mobile-destinations">
                                <slick :options="slickOptions">
                                    <div class="col-12">
                                        <ImageCard title="Agronegocios." avatar="impact-agronegocios"
                                            :list="['Prácticas regenerativas, orgánicas y precisión.', 'Agricultura, apicultura y ganadería.']"
                                            bgImg="biodiversidad" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard title="Conservación." avatar="biodiversidad"
                                            :list="['Ecoturismo.', 'Certificación bonos de carbono.', 'Manejo forestal.']"
                                            bgImg="biodiversidad" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard title="Construcción." avatar="impact-construccion"
                                            :list="['Remodelaciones.', 'Edificaciones ecoeficientes.']"
                                            bgImg="construccion" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard title="Energia." avatar="energia"
                                            :list="['Energía renovable.', 'Eficiencia energética']" bgImg="energia" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard title="Movilidad." avatar="movilidad"
                                            :list="['Vehículos híbridos.', 'Vehículos eléctricos.']" bgImg="movilidad" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard title="Residuos." avatar="residuos"
                                            :list="['Economía circular.', 'Reuso y reciclaje.', 'Materiales alternativos.']"
                                            bgImg="residuos" />
                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="container">
                <div class="section-heading heading-left mb-0">
                    <!-- WEB -->
                    <div class="row">
                        <div class="col-lg-12 mb--30">
                            <h2 class="font-weight-100 text-wrap-balance">
                                Empresas que generan <span class="bold">bienestar social.</span>
                            </h2>
                        </div>
                        <div class="col-lg-12">
                            <div class="row web-destinations">
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="100">
                                    <ImageCard 
                                        title="Agua." 
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Uso eficiente de recursos hídricos.', 'Captación y almacenamiento.', 'Higiene y saneamiento.']"
                                        bgImg="water" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="200">
                                    <ImageCard 
                                        title="Conectividad." 
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Servicios de telecomunicación universal y asequible.', 'Giros de negocio por Aplicaciones.']"
                                        bgImg="wifi" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="300">
                                    <ImageCard 
                                        title="Educación." 
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Instituciones educativas.', 'Profesionales de la educación.']"
                                        bgImg="education" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="400">
                                    <ImageCard 
                                        title="Salud." 
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Instituciones de salud', 'Profesionales de la salud.']" 
                                        bgImg="health" />
                                </div>
                            </div>
                            <!-- MOBILE -->
                            <div class="mobile-destinations">
                                <slick :options="slickOptions">
                                    <div class="col-12">
                                        <ImageCard 
                                            title="Agua." 
                                            :avatar="null"
                                            :isBanner="true"
                                            :list="['Uso eficiente de recursos hídricos.', 'Captación y almacenamiento.', 'Higiene y saneamiento.']"
                                            bgImg="water" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard 
                                            title="Conectividad." 
                                            :avatar="null"
                                            :isBanner="true"
                                            :list="['Servicios de telecomunicación universal y asequible.']"
                                            bgImg="wifi" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard 
                                            title="Educación." 
                                            :avatar="null"
                                            :isBanner="true"
                                            :list="['Instituciones educativas.', 'Profesionales de la educación.']"
                                            bgImg="education" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard 
                                            title="Salud." 
                                            :avatar="null"
                                            :isBanner="true"
                                            :list="['Instituciones de salud', 'Profesionales de la salud.']" 
                                            bgImg="health" />
                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ImageCard from '../partials/image-card.vue';
import Slick from 'vue-slick';
export default {
    name: "FundDestinations",
    props: ["needsPadding"],
    components: {
        ImageCard,
        Slick
    },
    data() {
        return {
            slickOptions: {
                infinite: true,
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            },
        }
    }
}

</script>

<style scoped>
.mobile-destinations {
    display: none;
}

.web-destinations {
    display: flex;
}
@media only screen and (max-width: 575px) {
    .mobile-destinations {
        display: block;
    }

    .web-destinations {
        display: none;
    }
}
</style>